// Separacja klasy pozwala na kilkukrotne osadzenie tego JS
// Dzieje sie tak ponieważ element obsługiwany przez tą klasę JS
// może być osadzony wielokrotnie na stronie (np. na Home)
(function () {
    class Zepter_V2_Products_Slider {
        constructor() {
            this.containers = document.getElementsByClassName("V2_Products_Slider_Container");
            // Jeśli brakuje kontenera z newsletterem
            if (!this.containers) {
                // Zakończ działanie tej klasy
                return;
            }
            // Uruchom slidery
            for (var i = 0; i < this.containers.length; i++) {
                this.SetupContainer(this.containers.item(i));
            }
        }
        SetupContainer(container) {
            var _a;
            // Jeśli ten kontener został już wcześniej skonfigurowany
            if (container.dataset.swiperIsInitialized) {
                // Zakończ tę metodę
                return;
            }
            // Zapamiętaj, że ten kontener został już skonfigurowany
            container.dataset.swiperIsInitialized = "true";
            // Ustal element ze swiperem
            const elSwiper = (_a = container.getElementsByClassName("V2_Products_Slider_Swiper")) === null || _a === void 0 ? void 0 : _a.item(0);
            if (elSwiper) {
                this.SetupSwiper(elSwiper);
            }
        }
        SetupSwiper(elSwiper) {
            //var swiperObject = null;
            elSwiper.dataset.swiperEnabled = "false";
            const swiperParams = {
                // Optional parameters
                direction: 'horizontal',
                enabled: true,
                loop: false,
                navigation: {
                    enabled: true,
                    nextEl: elSwiper.parentElement.querySelector('[class*="V2_Products_Slider_Swiper_Button_Next"]'),
                    prevEl: elSwiper.parentElement.querySelector('[class*="V2_Products_Slider_Swiper_Button_Prev"]'),
                    disabledClass: 'NavigationButtonDisabled',
                    navigationDisabledClass: 'NavigationButtonDisabled',
                },
                breakpoints: {
                    // when window width is >= 320px
                    //320: {
                    //    slidesPerView: 1,
                    //    spaceBetween: 20
                    //},
                    10: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    950: {
                        slidesPerView: 2,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    1220: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    1536: {
                        slidesPerView: 4,
                        spaceBetween: 10
                    }
                },
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },
                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                on: {
                    //afterInit: (swiper) => {
                    //    swiperObject = swiper;
                    //},
                    resize: (swiper) => {
                        swiperController(swiper);
                    }
                }
            };
            const swiperIsEnabled = (swiper) => {
                let sw = elSwiper.clientWidth;
                let sl = elSwiper.getElementsByClassName("swiper-slide").length;
                let swiperEnabled = false;
                if (sw < 640)
                    swiperEnabled = sl > 1;
                else if (sw >= 640 && sw < 1000)
                    swiperEnabled = sl > 2;
                else if (sw >= 1000 && sw < 1200)
                    swiperEnabled = sl > 3;
                else if (sw >= 1200)
                    swiperEnabled = sl > 4;
                return swiperEnabled;
            };
            const prevSlide = () => {
                // @ts-ignore
                var swiper = elSwiper.swiper;
                if (swiper) {
                    //console.log(swiper.activeIndex)
                    swiper.slidePrev();
                    //swiper.slideTo(swiper.activeIndex - 1);
                    console.log(`prev ${swiper.activeIndex - 1}`);
                }
                else {
                    console.log(`prev - [swiper] engine not available`);
                }
            };
            const nextSlide = () => {
                // @ts-ignore
                var swiper = elSwiper.swiper;
                if (swiper) {
                    //console.log(swiper.activeIndex)
                    swiper.slideNext();
                    //swiper.slideTo(swiper.activeIndex + 1);
                    console.log(`next ${swiper.activeIndex + 1}`);
                }
                else {
                    console.log(`next - [swiper] engine not available`);
                }
            };
            var swiperControllerTimeout = null;
            const swiperController = function (swiper) {
                window.clearTimeout(swiperControllerTimeout);
                swiperControllerTimeout = window.setTimeout(() => {
                    if (swiper) {
                        swiper.params.enabled = swiperIsEnabled(swiper);
                        swiper.params.navigation.enabled = swiperIsEnabled(swiper);
                        window.setTimeout(() => {
                            var _a, _b;
                            //console.log(elSwiper, `enabled: ${swiper.params.enabled}, loop: ${swiper.params.loop}`)
                            swiper.slideTo(0);
                            (_a = elSwiper.parentElement.querySelector('[class*="V2_Products_Slider_Swiper_Button_Prev"]')) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", prevSlide);
                            (_b = elSwiper.parentElement.querySelector('[class*="V2_Products_Slider_Swiper_Button_Next"]')) === null || _b === void 0 ? void 0 : _b.removeEventListener("click", nextSlide);
                            window.setTimeout(() => {
                                var _a, _b;
                                swiper.update();
                                (_a = elSwiper.parentElement.querySelector('[class*="V2_Products_Slider_Swiper_Button_Prev"]')) === null || _a === void 0 ? void 0 : _a.addEventListener("click", prevSlide);
                                (_b = elSwiper.parentElement.querySelector('[class*="V2_Products_Slider_Swiper_Button_Next"]')) === null || _b === void 0 ? void 0 : _b.addEventListener("click", nextSlide);
                                //elSwiper.parentElement.querySelector('[class="V2_Products_Slider_Swiper_Button_Prev"]')?.classList.add("NavigationButtonDisabled");
                            }, 500);
                        }, 500);
                    }
                }, 500);
            };
            try {
                // @ts-ignore
                var swiper = new Swiper(elSwiper, swiperParams);
                window.setTimeout(() => {
                    swiperController(swiper);
                }, 1000);
            }
            catch (e) {
                console.groupCollapsed("Unable to initialize Swiper Slider with products tiles.");
                console.warn(e);
                console.groupEnd();
            }
        }
    }
    // Uruchom klasę
    new Zepter_V2_Products_Slider();
})();
//# sourceMappingURL=Products_Slider.js.map